import React, { FC, useCallback, useEffect, useState } from "react";
import { Row, Col, Button, Dropdown } from "antd";
import { ReactSVG } from "react-svg";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { useDispatch } from "react-redux";
import { ENCRYPT_TOKEN } from "reducers/authReducer";
import { getAvatar, getFriendUserInfo, pageTypeMap } from "utils/chatUtils";

const SearchCard: FC<{
  active?: boolean;
  onClick?: () => void;
  item?: SelectedSearchItem;
  calling?: boolean;
  onCopy?: any;
  onDelete?: any;
  onLeave?: any;
  screens?: any;
  setScreens?: any;
}> = ({
  active,
  onClick,
  item,
  calling,
  onCopy,
  onDelete,
  onLeave,
  screens,
  setScreens,
}) => {
  const [count, setCount] = useState<number>(0);
  const type: string =
    pageTypeMap[item?.persistent?.static?.metadata?.type] || "blue";
  const { allUsers } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const handleVideoIconClick = () => {
    // const user = allUsers?.find(
    //   (obj) => obj.id === localStorage.getItem("RID")
    // );
    const livekitUrl = `${process.env.REACT_APP_VIDEO_URI}?pageId=${item?.pageId}&u=${localStorage.getItem("RID")}&o=${localStorage.getItem("selectedOrg") || "cudb-live"}&metadata=${localStorage.getItem("RID")}`
    window.open(
      livekitUrl,
      "_blank"
    );

    // dispatch(
    //   ENCRYPT_TOKEN({
    //     data: {
    //       payload: JSON.stringify({
    //         userId: localStorage.getItem("RID"),
    //         userBeamId: user?.beamId,
    //         connectionId: `${localStorage.getItem("CID")}`,
    //         pageId: item?.pageId,
    //         pageTitle:
    //           item?.persistent?.static?.metadata?.title ||
    //           (item?.persistent?.static?.metadata?.type === "friend" &&
    //           getFriendUserInfo(allUsers,item?.persistent?.static?.metadata?.members?.users)
    //             ?.beamId
    //             ? getFriendUserInfo(allUsers,
    //                 item?.persistent?.static?.metadata?.members?.users
    //               )?.beamId
    //             : `Page ${item?.pageId}`),
    //       }),
    //     },
    //     callback: (token) => {
    //       window.open(
    //         `${process.env.REACT_APP_VIDEO_URI}/room/${token.encryptedPayload}`,
    //         "_blank"
    //       );
    //     },
    //   })
    // );
  };


  let clsName = "search-card";
  if (active) {
    clsName += " active-card";
  }


  const openInNewWindow = () => {
    window.open(window.location.origin + `/page/${item?.pageId}`, "_blank");
  };

  useEffect(() => {
    if (item) setCount(getCount(item));
  }, [item]);

  const getCount = (item: SelectedSearchItem) => {
    try {
      if (
        parseInt(item?.lastRead?.pageMessageId ?? -1) <
        parseInt(item?.lastSent?.pageMessageId ?? -1)
      ) {
        return 1;
      } else {
        return 0;
      }
    } catch (e) {
      return 0;
    }
  };

  const onDoubleClick = (page) => {
    console.log("on double click page", page);
    if (
      page?.persistent?.static?.profile?.subType
    ) {
      setScreens({
        ...screens,
        iframe: true,
        iframeUrl: `${process.env.REACT_APP_SHARED_URI}/${
          page?.persistent?.static?.profile?.subType
        }?userId=${localStorage.getItem(
          "RID"
        )}&connectionId=${localStorage.getItem("CID")}&pageId=${page.pageId}`,
      });
    }
  };

  const menu = (
    <ul className="user-dropdown">
      <li
        onClick={() => {
          openInNewWindow();
        }}
      >
        <span className="ml-3">New window</span>
      </li>
      <li
        onClick={() => {
          onLeave(item?.pageId);
        }}
      >
        <span className="ml-3">Leave</span>
      </li>
      <li
        onClick={() => {
          onCopy("Copy", item?.pageId);
        }}
      >
        <span className="ml-3">Copy</span>
      </li>
      <li
        onClick={() => {
          onCopy("Merge", item?.pageId);
        }}
      >
        <span className="ml-3">Merge</span>
      </li>

      {item?.currentUserRole === "edit" && (
        <li
          onClick={() => {
            console.log("item here", item);
            onDelete(item?.pageId);
          }}
        >
          <span className="ml-3">Delete</span>
        </li>
      )}
    </ul>
  );
  return (
    <div
      className={`${clsName} ${
        item?.memberActive ? type : "white"
      }-card cursor-pointer`}
      onClick={onClick}
      onDoubleClick={() => {
        onDoubleClick(item);
      }}
    >
      {item?.nonpersistent?.static?.live?.status?.color && (
        <div
          className="spin-number"
          style={{
            background: item?.nonpersistent?.static?.live?.status?.color,
          }}
        >
          <span></span>
        </div>
      )}

      <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
        {item?.persistent?.static?.metadata?.type !== "friend" ? (
          <ReactSVG
            src={getAvatar(item)}
            className="colorable mark-icon"
          />
        ) : (
          <img
            src={
              getFriendUserInfo(allUsers,item?.persistent?.static?.metadata?.members?.users)
                ?.profileImage ?? "/images/users/user.png"
            }
            className="user-avatar"
            style={{ borderRadius: "50%" }}
            width={42}
            height={42}
            alt=""
          />
        )}
      </Dropdown>
      <div className="d-flex w-full">
        <div className="ml-2">
          <h3>
            {item?.persistent?.static?.metadata?.title ||
              (item?.persistent?.static?.metadata?.type === "friend" &&
              getFriendUserInfo(allUsers,item?.persistent?.static?.metadata?.members?.users)
                ?.beamId
                ? getFriendUserInfo(allUsers,
                    item?.persistent?.static?.metadata?.members?.users
                  )?.beamId
                : `Page ${item?.pageId}`)}
          </h3>
          <Row>
            <Col className="card-info date-info mr-2">
              <ReactSVG src="/images/refresh-icon.svg" className="svg-icon" />
              <p className="text-black">
                {moment(
                  item.lastSent?.updatedAt ??
                    item.persistent.static.metadata.createdAt
                ).format("MM/DD/YYYY hh:mm a")}
              </p>
            </Col>
            {item.memberActive ? (
             item.lastSent?.message && <Col
                className="card-info message-info mr-2"
                style={{
                  background: count !== 0 ? "rgb(80, 138, 250)" : undefined,
                }}
              >
                <p
                  className="text-black"
                  style={{ color: count !== 0 ? "#fff" : undefined }}
                >
                  {item.lastSent?.message ?? ""}
                </p>
              </Col>
            ) : (
              <Col
                className="card-info message-info mr-2"
                style={{
                  background: "rgb(80, 138, 250)",
                }}
              >
                <p className="text-black" style={{ color: "#fff" }}>
                  Pending Invitation
                </p>
              </Col>
            )}
          </Row>
        </div>

        {item?.activeIot && (
          <img
            className="ml-2 message-type cursor-pointer"
            src={
              item?.activeIot?.includes(localStorage.getItem("RID"))
                ? "/images/iot_blue.png"
                : "/images/IoT-icon.png"
            }
            alt=""
          />
        )}

        {calling && (
          <Button
            className="beam-btn ml-2"
            onClick={() => {
              handleVideoIconClick();
            }}
          >
            <ReactSVG src="/images/call-icon.svg" className="colorable" />
          </Button>
        )}
      </div>
    </div>
  );

};

export default SearchCard;
